export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div class="${this.classes.containerClasses}">
      <ul
        id="${this.ids.id}"
        class="${this.classes.classes}"
      >${this.getItemLists()}</ul>
    </div>`
  }

  getItemLists() {
    return this.content
      .items
      .map(item => `<li class="${this.classes.listsClasses}">${this.getContentIcon()} ${this.getItemTitle(item)}</li>`)
      .join('');
  }

  getItemTitle(item) {
    return item.title
  }

  getItemDescription(item) {
    return item.description
  }

  getIcon() {
    if (!this.content.hasIcon) return '';
    return `<i class="${this.content.class} ${this.content.icon}"/>`
  }

  getContentIcon() {
    if (!this.content.hasIcon) return '';
    return `<div
      class="wf-px-2 wf-flex wf-items-center"><div
      class="wf-w-10 wf-h-10 wf-flex wf-items-center wf-justify-center"
      >${this.getIcon()}</div></div>`;
  }
}
